import { useEffect, useState } from "react";
import DateFilter from "../common/DateFilter";
import { PDFIcon } from "../common/Icons";
import { useGetManualsQuery } from "../../app/services/manuals";
import { CircularProgress } from "@mui/material";
import {
  generateYear,
  useGetCategoryAllListQuery,
} from "../../app/services/category";
import { NavLink, useNavigate } from "react-router-dom";
import { useTranslation, withTranslation } from "react-i18next";
import InfiniteScroll from "react-infinite-scroll-component";
import { useInfiniteQuery } from "@tanstack/react-query";
const filterData = [
  {
    id: 1,
    name: "Company",
    color: "#6695C1",
  },
  {
    id: 2,
    name: "Announcement",
    color: "#AF7BA4",
  },
  {
    id: 3,
    name: "Employee",
    color: "#FF9248",
  },
  {
    id: 4,
    name: "Holiday",
    color: "#8F8F8F",
  },
  {
    id: 5,
    name: "IT",
    color: "#82AD57",
  },
];
const years: Number[] = generateYear();
// const manuals=[
//     {
//         id:1,
//         label:'Employee Handbook',
//         link:'https://www.antennahouse.com/hubfs/xsl-fo-sample/pdf/basic-link-1.pdf'
//     },
//     {
//         id:1,
//         label:'Employee Handbook',
//         link:'https://www.antennahouse.com/hubfs/xsl-fo-sample/pdf/basic-link-1.pdf'
//     },
//     {
//         id:1,
//         label:'Employee Handbook',
//         link:'https://www.antennahouse.com/hubfs/xsl-fo-sample/pdf/basic-link-1.pdf'
//     },
//     {
//         id:1,
//         label:'Employee Handbook',
//         link:'https://www.antennahouse.com/hubfs/xsl-fo-sample/pdf/basic-link-1.pdf'
//     },
//     {
//         id:1,
//         label:'Employee Handbook',
//         link:'https://www.antennahouse.com/hubfs/xsl-fo-sample/pdf/basic-link-1.pdf'
//     },
//     {
//         id:1,
//         label:'Employee Handbook',
//         link:'https://www.antennahouse.com/hubfs/xsl-fo-sample/pdf/basic-link-1.pdf'
//     },
//     {
//         id:1,
//         label:'Employee Handbook',
//         link:'https://www.antennahouse.com/hubfs/xsl-fo-sample/pdf/basic-link-1.pdf'
//     },
//     {
//         id:1,
//         label:'Employee Handbook',
//         link:'https://www.antennahouse.com/hubfs/xsl-fo-sample/pdf/basic-link-1.pdf'
//     },
//     {
//         id:1,
//         label:'Employee Handbook',
//         link:'https://www.antennahouse.com/hubfs/xsl-fo-sample/pdf/basic-link-1.pdf'
//     },
//     {
//         id:1,
//         label:'Employee Handbook',
//         link:'https://www.antennahouse.com/hubfs/xsl-fo-sample/pdf/basic-link-1.pdf'
//     }
// ]
const Manual = (props: any) => {
 const {t}=useTranslation();
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [filter, setFilter] = useState<string>("");
  const [categoriesData, setCategories] = useState<any>([]);
  const [filterYear, setFilterYear] = useState<string>("");
  const [sort, setSort] = useState<string>("");
  const [manuals, setManuals] = useState<any>([]);
  const { data: categories } = useGetCategoryAllListQuery();
  const { data: manualsData, isLoading, isFetching,error } = useGetManualsQuery({
    category: filter == "0" ? 'all' : filter,
    year: filterYear,
    sort: sort,
    page: page,
    limit:10
  });
  useEffect(() => {
    setManuals([]);
    setPage(1);
    setHasMore(true);
  }, [filter, filterYear, sort]);
  useEffect(() => {
    if (manualsData) {
      setManuals((prev:any) =>
        page === 1 ? manualsData.ManualList?.data : [...prev, ...manualsData.ManualList?.data]
      );
      const currentTotal = page === 1
        ? manualsData.ManualList?.data?.length || 0
        : manuals.length + (manualsData.ManualList?.data?.length || 0);
      if (currentTotal >= manualsData?.ManualList?.total) {
        setHasMore(false);
      }
    }
  }, [manualsData]);
  useEffect(() => {
    if (categories) {
      setCategories([{ id: 0, name: t('all') }, ...categories?.categoryList]);
    }
  }, [categories]);
  const filterByDate = (sortType: string) => {
    setSort(sortType);
  };
  const loadMore = () => {
    if (!isFetching && hasMore) {
      setPage((prev) => prev + 1);
    }
  };
  return (
    <div className="px-5">
      <DateFilter
        filter={filter}
        setFilter={setFilter}
        years={years}
        setFilterYear={setFilterYear}
        filterYear={filterYear}
        filterData={categoriesData}
        filterByDate={filterByDate}
        t={t}
      />
      <ul className="mt-4 mb-16 max-h-[68vh] overflow-auto h-full min-h-[250px]">
        {isLoading===false && isFetching===false && manuals?.length<=0 && <p className="text-body-sm font-normal text-sat_darkblackv2">{t('no_more')}</p>}
          {manuals?.map((manual: any, key: number) => {
            const pathname = "/pdfview?" + manual.file_path;
            return (
              <li
                key={key}
                className="bg-sat_lightgray p-3 rounded-lg mb-3 w-full"
              >
                <NavLink
                  to={{ pathname: '/pdfview' }}
                  state={
                    { is_download: manual.is_download, filepath: manual.file_path }
                  }
                  className=" w-full"
                >
                  <div className="flex items-center">
                    <PDFIcon
                      width={24}
                      height={24}
                      className="min-w-6 min-h-6"
                    />
                    <p className="text-body-sm font-normal text-sat_darkblackv2 ml-3 text-left">
                      {manual.file_name}
                    </p>
                  </div>
                </NavLink>
              </li>
            );
          })}
          {error && <p>Error loading data</p>}

          {hasMore && (
            <button onClick={loadMore} disabled={isFetching} className="underline underline-offset-2 text-body-sm font-normal text-sat_darkblackv2">
              {isFetching ? <CircularProgress/> : t('view_more')}
            </button>
          )}
        </ul>
    </div>
  );
};
export default withTranslation('common')(Manual);
